'use strict';

var processInclude = require('base/util.js');
$(document).ready(function () {
    processInclude(require('./components/storeLocator/storeLocator'));
    processInclude(require('./components/storeLocator/formSpaceWorkaround'));
});